import {FC, useState} from "react";
import IconFilters from "../../assets/icons/filters-sidebar.svg";
import IconClose from "../../assets/icons/close-sidebar.svg";
import {SidebarFiltersPanel} from "./SidebarFiltersPanel";
import {
  IFintechFilters,
  IFintechWeakSignalsFilters,
} from "../../pages/Fintech/FintechDashboard.type";
import {IdashboardFilters} from "../../pages/Dashboard/Dashboard.type";
import {IEsgFilters} from "../../pages/Esg/EsgDashboard.type";
import {
  IAuthority,
  IStateInitiativeFilters,
} from "../../pages/StateInitiative/StateInitiative.type";
import {ITypeRadar} from "../../types";
import {Badge, BadgeProps, styled} from "@mui/material";
import {BtnImage} from "./style";

interface IProps {
  filters:
    | IFintechFilters
    | IdashboardFilters
    | IEsgFilters
    | IStateInitiativeFilters;
  onFilterChange: <T>(filter?: string, value?: T, isReset?: boolean) => void;
  filterWeakSignals?: IFintechWeakSignalsFilters;
  typeRadar: ITypeRadar;
  setIsShowAllLabels: React.Dispatch<React.SetStateAction<boolean>>;
  isShowAllLabels: boolean;
  isOpenPanel?: boolean;
  onCloseOTherAllPanels?: () => void;
  isVisibleFiltersPanel?: boolean;
  setIsVisibleFiltersPanel?: React.Dispatch<React.SetStateAction<boolean>>;
  authorities?: IAuthority[];
  isLogin?: boolean;
  role?: string | null;

  isNationalProjects?: boolean;
  setIsNationalProjects?: React.Dispatch<React.SetStateAction<boolean>>;

  isBenefitsSubsidies?: boolean;
  setIsBenefitsSubsidies?: React.Dispatch<React.SetStateAction<boolean>>;
}
const StyledBadge = styled(Badge)<BadgeProps>(({theme}) => ({
  "& .MuiBadge-badge": {
    right: 0,
    top: 20,
    backgroundColor: "#22272B",
    padding: "0 4px",
  },
}));
export const SidebarFilters: FC<IProps> = ({
  typeRadar,
  filters,
  onFilterChange,
  filterWeakSignals,
  setIsShowAllLabels,
  isShowAllLabels,
  isOpenPanel,
  onCloseOTherAllPanels,
  isVisibleFiltersPanel,
  setIsVisibleFiltersPanel,
  authorities,
  isLogin,
  role,

  isNationalProjects,
  setIsNationalProjects,

  isBenefitsSubsidies,
  setIsBenefitsSubsidies,
}) => {
  const handleClickShowFilters = () => {
    setIsVisibleFiltersPanel?.((prev: boolean) => !prev);
    onCloseOTherAllPanels?.();
  };
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
      }}
    >
      <BtnImage
        isVisibleFiltersPanel={isVisibleFiltersPanel ?? false}
        onClick={handleClickShowFilters}
      >
        {isVisibleFiltersPanel ? (
          <img
            src={isVisibleFiltersPanel ? IconClose : IconFilters}
            alt="filters"
            style={{}}
          />
        ) : (
          <>
            <StyledBadge
              badgeContent={
                Object.values(filters as IEsgFilters).filter(
                  (item) => item.turnOn
                ).length
              }
              color="secondary"
            >
              <img
                src={isVisibleFiltersPanel ? IconClose : IconFilters}
                alt="filters"
                style={{}}
              />
            </StyledBadge>
          </>
        )}
      </BtnImage>
      <div
        style={{
          color: "rgba(255, 255, 255, 0.6)",
          fontSize: "16px",
          fontWeight: "600",
          marginLeft: "5px",
          position: "absolute",
          left: "40px",
          top: "10px",
          opacity: isOpenPanel ? "1" : "0",
          width: isOpenPanel ? "auto" : "0px",
          overflow: "hidden",
          transition: "all 0.3s",
          cursor: "pointer",
        }}
        onClick={handleClickShowFilters}
      >
        Фильтры
      </div>
      <SidebarFiltersPanel
        isVisible={isVisibleFiltersPanel || false}
        onClose={() => setIsVisibleFiltersPanel?.(false)}
        typeRadar={typeRadar}
        filters={filters}
        onFilterChange={onFilterChange}
        isShowAllLabels={isShowAllLabels}
        setIsShowAllLabels={setIsShowAllLabels}
        authorities={authorities}
        isLogin={isLogin}
        role={role}
        isNationalProjects={isNationalProjects}
        setIsNationalProjects={setIsNationalProjects}
        isBenefitsSubsidies={isBenefitsSubsidies}
        setIsBenefitsSubsidies={setIsBenefitsSubsidies}
      />
    </div>
  );
};
